export default __webpack_public_path__ + "static/media/export_excel_icon.39fbeace.svg";